module.exports = __webpack_public_path__ + "img/basket-item.46510c96.png";